<template>
  <section>
    <translate tag="p">
      No information has been provided by the owner.
    </translate>
    <p>
      <translate tag="strong"> Site owner? </translate> -
      <i18n-t
        keypath="{addInformation} in the Manager Portal to describe how wonderful your site is."
      >
        <template #addInformation>
          <translate
            tag="a"
            target="_blank"
            :href="`https://www.pitchup.com/${
              $i18n.locale !== 'en-gb' ? $i18n.locale + '/' : ''
            }supplier2/campsite/${campsiteSlug}/`"
          >
            add information
          </translate>
        </template>
      </i18n-t>
    </p>
    <p>
      <translate
        tag="a"
        :href="`https://www.pitchup.com/${
          $i18n.locale !== 'en-gb' ? $i18n.locale + '/' : ''
        }about/contact/`"
        target="_blank"
      >
        I don't yet have login details </translate
      >.
    </p>
  </section>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteNoDescription extends Vue {
  @Prop({ required: true })
  campsiteSlug: string
}

export default toNative(CampsiteNoDescription)
</script>

<style scoped>
section {
  font-size: var(--body);
}
</style>
